/** Resolves current presentation identity in this language resource. */
import raw from "./en.json";
import {brandCopy} from "../../../config/brand";
export default brandCopy(raw);
